import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UserRolesActions = {
  migrateUserRole: async (_, user) => {
    return axiosRequest.patch(`/admin/users/${user.id}/migrate_role`).
      then(({ data }) => data).
      catch(handleError)
  },
}
